export const isPublicPollPath = (pathname) =>
  pathname === "/thank-you" || pathname.startsWith("/submit-poll/");
